import React from 'react'
import ProtectionSuccess from '../protection-success'

const ProtectionSuccessFr = () => {
    return <ProtectionSuccess languageCode="en" />
}

export default ProtectionSuccessFr
